<template>
	<div class="networkroom">
		
		<headerview :cur="4"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13 min-h">
				<div class="tipcon">
					
					<tipconNav :title="'网络课堂'" :name="[{label:'学习资料',url:'/studytrain'},{label:'网络课堂',url:'/networkroom'}]" :imgtype="'2'" width="2.05"></tipconNav>
				</div>
				
				<div class="networkclass">
					<networkroom></networkroom>
				</div>
							
			</div>	
			
		</div>
		
		<footview></footview>
		
	</div>
	
</template>

<script>

import networkroom from "../../../com/networkroom.vue";
export default {
  components: {
  	  networkroom,
  },
  
  data: function() {
    return {
      pageNo:1,
      total:5,
      pageSize:5,
	  
    };
  },
  
  mounted() {
		this.$onScrollT()
  },

  methods: {
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.networkroom{
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
		}
			
	}
}

</style>
